import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeURI'
})
export class EncodeUriPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return encodeURIComponent(value);
  }
}
